export default __webpack_public_path__ + "static/media/email-verify.2bc9b242.png";